// extracted by mini-css-extract-plugin
export default {"container":"a_pR1ttYBj4dUj38NEaV"};